import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { numericIdParam } from './params.ts'
import { rootRoute } from './root.tsx'

// The kits of one campo, and where one is installed from stock. A route of its own and not
// a card on the campo: installing is a form.

export const pitchKitsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/pitches/$id/kits',
  params: numericIdParam,
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/pitch-kits.tsx')),
})
